define('payment/templates/withdraw-sender',['jquery','boxes/helpers/box-loading', 'boxes/helpers/payment-sender-helper', 'payment/handlers/kyc-validator'], function ($,boxLoading, paymentSenderHelper, kycValidator) {
	'use strict';

	function verifyKYC(withdrawBox) {
		var paymentController = withdrawBox.model.paymentController;
		var amount = withdrawBox.$box.find('.amount-box').find('input').val();
		var paymentMethodId = paymentController.selectedFormMethodId;
		var currency = fetchCurrency(withdrawBox);
		var formTemplateCode = paymentController.getSelectedFormTemplate().paymentMethod.formTemplateCode;

		kycValidator.init(withdrawBox);
		return kycValidator.validate(paymentMethodId, amount, currency, formTemplateCode);
	}

	function fetchCurrency(withdrawBox) {
		var currency;
		var paymentController = withdrawBox.model.paymentController;
		if (paymentController.selectedCurrency === undefined) {
			currency = paymentController.playerCurrency;
		} else {
			currency = paymentController.selectedCurrency;
		}
		return currency;
	}

	function showKYCPopupMessage(withdrawBox, validationData) {
		withdrawBox.model.showKYCPopupMessage(withdrawBox, {
			title: validationData.kycPopup.contentKYC.uploadTitle,
			message: validationData.kycPopup.contentKYC.message,
			uploadDocuments: validationData.kycPopup.contentKYC.uploadDocuments,
			confirmButtonText: validationData.kycPopup.confirm,
			closeButtonText: validationData.kycPopup.close
		});
	}

	function showKYCErrorMessage(withdrawBox, validationData) {
		boxLoading.removeLoading(withdrawBox.$box);
		withdrawBox.model.showFailMessage(withdrawBox, {
			title: validationData.kycPopup.title,
			message: validationData.kycPopup.message
		});
	}

	function send(formTemplate, withdrawBox) {
		// IMPORTANT: this has to be done before the ajax calls, otherwise popup window will be blocked
		formTemplate.sendHandler.init(formTemplate.paymentMethod.methodName);

		$.when(verifyKYC(withdrawBox)).done(function (validationData) {
			if (validationData.needValidation === 'error') {
				showKYCErrorMessage(withdrawBox, validationData);
			}
			else if (validationData.needValidation) {
				showKYCPopupMessage(withdrawBox, validationData);
			} else {
				withdrawBox.$controller.trigger('skipEvent');
				paymentSenderHelper.verifyAndSendPayment(withdrawBox, formTemplate, '/pp?flow=CheckWithdrawLimits');
			}
		});
	}

	var withdrawSender = {};
	withdrawSender.send = send;
	return withdrawSender;
});

